// Admin list's own workflow status (controllers/sales/SalesOrderController.js's orderStatus,
// Processing/Action Required/Processed/Voided) - distinct from paymentStatus.js's Paid/Pending/etc,
// which tracks amountPaid vs total, not workflow progress. The row's own status badge intentionally
// uses different wording than the tab label for the same underlying state ("Action Required" tab,
// "Pending Agent" badge - confirmed against the design) - resolveOrderStatusLabel is that mapping.
export const resolveOrderStatusVariant = status => {
  if (status === 'Processing') return 'light-primary'
  if (status === 'Action Required') return 'light-warning'
  if (status === 'Processed') return 'light-success'
  if (status === 'Voided') return 'light-danger'
  return 'light-secondary'
}

export const resolveOrderStatusLabel = status => {
  if (status === 'Action Required') return 'Pending Agent'
  return status || '–'
}

// Mirrors helpers/promotion.js's PURCHASE_OPTION_LABEL map (backend) - same wording, since this is
// display-only, not sent back anywhere.
export const purchaseOptionLabel = paymentType => {
  if (paymentType === 'bookingfee') return 'Book for 10 days'
  if (paymentType === 'downpayment') return 'Pay downpayment'
  if (paymentType === 'fullpayment') return 'Pay in full'
  return paymentType || '–'
}
